import React, { useState } from 'react';
import './Food.css';

const getGIColor = (gi) => {
  if (gi < 40) return '#f14b0eff'; // Blue - Low GI
  if (gi < 60) return '#035f31ff'; // Yellow - Medium GI
  return '#f87171';              // Red - High GI
};

const FoodList = ({ items, onSelect }) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleDetails = (name) => {
    setExpandedItems(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  return (
    <div className="food-list">
      {items.map(item => {
        const isExpanded = expandedItems[item.name];
        return (
          <div
            key={item.name}
            className="food-card"
            style={{ borderLeft: `8px solid ${getGIColor(item.gi)}` }}
            onClick={() => onSelect(item)}
          >
            <div className="food-icon">🍃</div>
            <div className="food-info">
              <h3>{item.name}</h3>
              <p><strong>GI:</strong> <span style={{ color: getGIColor(item.gi) }}>{item.gi}</span></p>
              <p><strong>Origin:</strong> {item.origin}</p>

              {isExpanded && (
                <div className="extra-details">
                  <p><strong>Category:</strong> {item.category}</p>
                  <p><strong>Nutrition:</strong> {item.nutrition}</p>
                  <p><strong>Description:</strong> {item.description}</p>
                </div>
              )}

              <button
                className="toggle-button"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering onSelect
                  toggleDetails(item.name);
                }}
              >
                {isExpanded ? 'Less' : 'More'}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FoodList;
